import WalletActionsCreator from "actions/walletActionsCreator";
import { useDispatch, useSelector } from "react-redux";
import { getWalletItems } from "selectors/wallet";
import { WalletItemResponse } from "types/Api/Wallet/walletItemResponse";

export interface IUseRetailerConfiguration {
  loadWalletItems: (clientId: string, accountV2: string) => Promise<void>;
  getWalletItems: () => WalletItemResponse[];
}

export default (isPayable = false): IUseRetailerConfiguration => {
  const dispatch = useDispatch();

  const getWalletItemsAction = WalletActionsCreator.getWalletItems;
  const getPayableWalletItemsAction =
    WalletActionsCreator.getPayableWalletItems;

  const walletItems = useSelector(getWalletItems);

  const loadWalletItems = (clientId: string, accountV2: string) =>
    new Promise<void>((resolve, reject) =>
      dispatch(
        isPayable
          ? getPayableWalletItemsAction(clientId, resolve, reject)
          : getWalletItemsAction(clientId, accountV2, resolve, reject)
      )
    );

  return {
    loadWalletItems,
    getWalletItems: () => walletItems,
  };
};
